exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-light{background-color:hsla(0,0%,100%,.4)!important}.fadeInDown{animation-duration:.3s;animation-delay:0s}.fadeOutUp{animation-duration:.3s;animation-delay:.3s}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-393d5212","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 18
// module chunks = 0